import axios, { AxiosError } from 'axios';
import { api } from '../configs/api/api';

// Interfaces
import { IUserData, IUserSignUpRequest } from '../interfaces/user.interfaces';
import { IAuthData } from '../interfaces/auth.interfaces';

export const AuthService = {
  signIn: async (email: string, password: string): Promise<{ data: IAuthData; status: number } | {
    data: any;
    status: number
  }> => {
    return await api.post('/company/login', { email, password, device_UDID: '123' })
      .then(result => {
        const { data, status } = result;
        return { data, status };
      })
      .catch((error: Error | AxiosError) => {
        if (axios.isAxiosError(error) && error.response) {
          const { data, status } = error.response;
          return { data, status };
        } else {
          return {
            data: { error: 'An error has occurred with API processing' },
            status: 500
          };
        }
      });
  },
  signUp: async (userRequest: IUserSignUpRequest): Promise<{ data: IAuthData; status: number } | {
    data: any;
    status: number
  }> => {
    return await api.post('/company/sign-up', userRequest)
      .then(result => {
        const { data, status } = result;
        return { data, status };
      })
      .catch((error: Error | AxiosError) => {
        if (axios.isAxiosError(error) && error.response) {
          const { data, status } = error.response;
          return { data, status };
        } else {
          return {
            data: { error: 'An error has occurred with API processing' },
            status: 500
          };
        }
      });
  },
  activateCode: async (temporary_token: string, code: string, type: string): Promise<{
    data: IUserData;
    status: number
  } | { data: any; status: number }> => {
    return await api.post('/company/activate-code', { temporary_token, code, type, device_UDID: '123' })
      .then(result => {
        const { data, status } = result;
        return { data, status };
      })
      .catch((error: Error | AxiosError) => {
        if (axios.isAxiosError(error) && error.response) {
          const { data, status } = error.response;
          return { data, status };
        } else {
          return {
            data: { error: 'An error has occurred with API processing' },
            status: 500
          };
        }
      });
  },
  resendCode: async (temporary_token: string, type: string)
    : Promise<{ data: { message: string; resend_access: string; status: string; }; status: number } | {
    data: any;
    status: number
  }> => {
    return await api.post('/company/resend-code', { temporary_token, type })
      .then(result => {
        const { data, status } = result;
        return { data, status };
      })
      .catch((error: Error | AxiosError) => {
        if (axios.isAxiosError(error) && error.response) {
          const { data, status } = error.response;
          return { data, status };
        } else {
          return {
            data: { error: 'An error has occurred with API processing' },
            status: 500
          };
        }
      });
  },
  forgotPassword: async (email: string) => {
    return await api.post('/company/forgot-password', { email, type: 'service_admin' }).then(result => {
      const { data, status } = result;
      return { data, status };
    })
      .catch((error: Error | AxiosError) => {
        if (axios.isAxiosError(error) && error.response) {
          const { data, status } = error.response;
          return { data, status };
        } else {
          return {
            data: { error: 'An error has occurred with API processing' },
            status: 500
          };
        }
      });
  },
  resendResetEmail: async (email: string) => {
    return await api.post('/company/resend-forgot-password-email', { email, type: 'service_admin' }).then(result => {
      const { data, status } = result;
      return { data, status };
    })
      .catch((error: Error | AxiosError) => {
        if (axios.isAxiosError(error) && error.response) {
          const { data, status } = error.response;
          return { data, status };
        } else {
          return {
            data: { error: 'An error has occurred with API processing' },
            status: 500
          };
        }
      });
  },
  checkResetPasswordToken: async (reset_token: string) => {
    return await api.get(`/reset-password/${reset_token}`).then(result => {
      const {data, status} = result;
      return {data, status};
    })
      .catch((error: Error | AxiosError) => {
        if (axios.isAxiosError(error) && error.response) {
          const {data, status} = error.response;
          return {data, status};
        } else {
          return {
            data: {error: 'An error has occurred with API processing'},
            status: 500
          };
        }
      });
  },
  resetPassword: async (reset_token: string, password: string, password_confirmation: string) => {
    return await api.post('/reset-password', { reset_token, password, password_confirmation }).then(result => {
      const { data, status } = result;
      return { data, status };
    })
      .catch((error: Error | AxiosError) => {
        if (axios.isAxiosError(error) && error.response) {
          const { data, status } = error.response;
          return { data, status };
        } else {
          return {
            data: { error: 'An error has occurred with API processing' },
            status: 500
          };
        }
      });
  }
}
